/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'beta_button': 'Neue Version aufrufen',
    'beta_content': 'Nutze ab sofort die Betaversion unserer überarbeiteten Oberfläche und gestellte das neue likvi mit deinem Feedback aktiv mit. Während des Betazeitraums kannst du frei zwischen der neuen und alten Version wechseln.',
    'beta_headline': 'Teste das neue likvi',
    'dashboard': 'Übersicht',
    'hide_yearly_average': 'Jahresdurchschnitt ausblenden',
    'last_invoices': 'Letzten Rechnungen',
    'show_yearly_average': 'Jahresdurchschnitt anzeigen'
  },

  /* english */
  en: {
    'beta_button': 'Visit new version',
    'beta_content': 'Start using the beta version of our new and overhauled interface and shape the new likvi with your feedback. During the beta phase, you can always switch between the new and old version.',
    'beta_headline': 'Test the new likvi',
    'dashboard': 'Dashboard',
    'hide_yearly_average': 'Hide yearly average',
    'last_invoices': 'Last invoices',
    'show_yearly_average': 'Show yealy average'
  }
}
